export default {
  "content": "<path d=\"M16.256 7.155l-6.5 7.5a1.001 1.001 0 01-1.509.003l-3.5-4 1.506-1.316 2.743 3.135 5.748-6.632 1.512 1.31z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};